'use client'

import { ButtonLink } from '../'
import { useTranslate } from '../../hooks'
import { type AgentUser, type UserUser } from '@repo/services'
import { Alert, Row, Typography } from '@repo/ui/components'
import Image from 'next/image'

interface KycAlertProps {
  className?: string
  data: UserUser | AgentUser
}

export const KycAlert = (props: KycAlertProps) => {
  const { className, data: authDetails } = props
  const { t } = useTranslate()

  const hasKyc =
    authDetails?.details?.kyc &&
    authDetails?.details?.kyc?.status === 'approved'

  if (hasKyc) return null

  const phone = authDetails?.phone
  const email = authDetails.email

  const kycStatus = authDetails?.details?.kyc?.status

  const kycStatusText = {
    waiting_for_review: t('common_kyc_waiting_for_review'),
    under_review: t('common_kyc_under_review'),
    rejected: t('common_kyc_rejected', {
      reason: authDetails?.details?.kyc?.comment || '',
    }),
  }

  return (
    <Row className={className}>
      <Alert
        color={
          kycStatus === 'under_review' || kycStatus === 'waiting_for_review'
            ? 'base'
            : 'alert'
        }
        className='flex-1'
        icon={null}
        hideIcon
        caption={
          <Row className='justify-between flex-col md:flex-row gap-sm md:gap-0 py-xs md:py-0'>
            <Image
              src='/images/gard.webp'
              alt='KYC Alert'
              width={48}
              height={48}
            />
            <Typography
              size='sm'
              weight='regular'
              className='flex-1 text-center md:text-right'
            >
              {!authDetails?.details?.kyc
                ? t('common_kyc_alert', { company_name: t('company_name') })
                : kycStatusText[kycStatus as keyof typeof kycStatusText]}
            </Typography>

            {(!authDetails?.details?.kyc ||
              (authDetails?.details?.kyc && kycStatus === 'rejected')) && (
              <ButtonLink
                variant='fill'
                size='sm'
                color='alert'
                buttonClassName='px-sm w-full md:w-auto'
                className='w-full md:w-auto'
                href={
                  phone
                    ? `/auth/quick-kyc?mobileOrEmail=${phone}`
                    : `/auth/kyc?mobileOrEmail=${email}`
                }
              >
                {t('common_kyc_title')}
              </ButtonLink>
            )}
          </Row>
        }
      />
    </Row>
  )
}
